export default {
  /**
   * @type {string} ログイン
   */
  login: '/login/',
};
